import Phaser from 'phaser';
import { UIStyle } from './UIStyle';

/** Jarak bawah hint ke titik jangkar (px) */
const HINT_GAP_ABOVE_ANCHOR = 10;

export class ObjectiveHint {
  private scene: Phaser.Scene;
  private container?: Phaser.GameObjects.Container;
  private label?: Phaser.GameObjects.Text;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  /**
   * Tampilkan hint di atas titik jangkar peta.
   * @param anchorY — Y dunia tempat hint "duduk" di atasnya (mis. atas label lokasi)
   */
  show(text: string, x: number, anchorY: number): void {
    this.hide();

    this.container = this.scene.add.container(x, anchorY);
    this.container.setDepth(15);

    this.label = this.scene.add.text(0, -HINT_GAP_ABOVE_ANCHOR, text, {
      ...UIStyle.onBrightBg(UIStyle.px(15), '#ffffff', true),
      backgroundColor: '#0a1218ee',
      padding: { x: 12, y: 7 },
      align: 'center',
      wordWrap: { width: 240 },
      lineSpacing: 4,
    });
    this.label.setOrigin(0.5, 1);

    this.container.add(this.label);
  }

  hide(): void {
    this.container?.destroy();
    this.container = undefined;
    this.label = undefined;
  }

  destroy(): void {
    this.hide();
  }
}
